import { Dialog } from './Overlay'

/**
 * I conteggi della eval hanno unità diverse: questa guida resta vicina alla pagina.
 * Il focus e Escape li gestisce `Dialog`.
 */
export const GuidaEsiti = ({ t, onClose }) => (
  <Dialog
    id="ae-guida"
    titolo={t.aeGuidaTitolo}
    sottotitolo={t.aeGuidaIntro}
    chiudiEtichetta={t.aeChiudiForm}
    onClose={onClose}
  >
    <div className="ae-dialog__corpo">
      <section className="ae-guida__soglia">
        <h3>{t.aeGuidaSogliaTitolo}</h3>
        <p>{t.aeGuidaSoglia}</p>
        <div className="ae-guida__esempi">
          <div>
            <span className="nbadge nbadge--ok">PASS</span>
            <strong>4/5 = 80%</strong>
            <span>{t.aeGuidaEsempioPass}</span>
          </div>
          <div>
            <span className="nbadge nbadge--err">FAIL</span>
            <strong>3/5 = 60%</strong>
            <span>{t.aeGuidaEsempioFail}</span>
          </div>
        </div>
        <p className="ae-muto">{t.aeGuidaSogliaNota}</p>
      </section>
      <section>
        <h3>{t.aeGuidaConteggiTitolo}</h3>
        <dl className="ae-guida__glossario">
          <div>
            <dt className="is-ok">{t.aeColVerdi}</dt>
            <dd>{t.aeGuidaVerdi}</dd>
          </div>
          <div>
            <dt className="is-ko">{t.aeColRossi}</dt>
            <dd>{t.aeGuidaRossi}</dd>
          </div>
          <div>
            <dt>{t.aeColErrori}</dt>
            <dd>{t.aeGuidaErrori}</dd>
          </div>
          <div>
            <dt>{t.aeColNonValidi}</dt>
            <dd>{t.aeGuidaNonValidi}</dd>
          </div>
          <div>
            <dt>{t.aeScenariSaltati}</dt>
            <dd>{t.aeGuidaSaltati}</dd>
          </div>
          <div>
            <dt>{t.aeColPassi}</dt>
            <dd>{t.aeGuidaAvanzamento}</dd>
          </div>
        </dl>
        <p className="ae-muto">{t.aeGuidaStorico}</p>
      </section>
    </div>
  </Dialog>
)
